module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/luna/luna_craters-ef5b730d5cb5d0dee460f4b08e5744a8.gif";